import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=641b9dda&scoped=true&"
import script from "./SettingIndex.vue?vue&type=script&lang=ts&"
export * from "./SettingIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b9dda",
  null
  
)

export default component.exports